import {AssayType} from './../../masterdata/models/assayType-enum';

export class SampleDetailsDTO {
  barcode: string;
  name: string;
  projectName: string;
  assayType: AssayType;
  concentration: number;
  positionCol: number;
  positionRow: number;
  newlyPlaced: boolean = false;
  targetPlateQuadrant?: string
  sourcePlateQuadrant?: string
}
